
// import React, { useState } from "react";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import SoftBox from "components/SoftBox";
// import Card from "@mui/material/Card"; 
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DataTable from "./DataTable";

// const TotalUsers = () => {
//   const [rows, setRows] = useState([]);
//   const [totalEntries, setTotalEntries] = useState(0);
//   const [page, setPage] = useState(1);
//   const [entriesPerPage, setEntriesPerPage] = useState(8);
//   const [loading, setLoading] = useState(false);
  
//   const handleEntriesChange = (newEntries) => {
//     setEntriesPerPage(newEntries);
//     setPage(1); // Reset to first page when entries per page change
//   };

//   const columns = [
//     { Header: "Question", accessor: "content", align: "left" },
    
// ];

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <div style={{ width: "100%", marginTop: "0px" }}>
//         <h3 style={{ textAlign: "center", paddingBottom: "0px" }}> Un Answered Details</h3>
//         <Card>
//           <SoftBox p={3} lineHeight={1.2}>
//             {loading ? (
//               <p style={{ textAlign: "center" }}>Loading data...</p>
//             ) : (
//               <>
//                 <div style={{ width: "100%" }}>
//                   <DataTable
//                     table={{ columns, rows }}
//                     entriesPerPage={{
//                       defaultValue: entriesPerPage,
//                       entries: [5, 10, 15],
//                     }}
//                     canSearch
//                     date
//                     csv
//                     showTotalEntries
//                     onEntriesChange={handleEntriesChange}
//                     totalPages={Math.ceil(totalEntries / entriesPerPage)}
//                   />
//                 </div>
//               </>
//             )}
//           </SoftBox>
//         </Card>
//       </div>
//     </DashboardLayout>
//   );
// };
// export default TotalUsers;





import React, {useState} from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import { Card } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "./DataTable";

const Unanswered_questions = () => {
  const [rows, setRows] = useState([])
  const [totalEntries, setTotalEntries] = useState(0)
  const [page , setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(0)
  const [loading, setLoading] = useState(true)

  const handleEntriesChange = (newEntries) => {
    setEntriesPerPage(newEntries);
    setPage(1)
  }

  const columns = [
    {Header : "Question", accessor : "question" , align : "left"},
    {Header : "IP Address", accessor : "ip_address" , align : "left"},
    {Header : "Date & Time", accessor : "created_at" , align : "left"},
    {Header : "Actions", accessor : "answer" , align : "left"}
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <div style={{width: " 100%" , marginTop : "0px"}}>
        <Card>
          <SoftBox p={3} lineHeight={1.2}>
            <div style={{width : "100%"}}>
           
              <DataTable 
                table = {{columns , rows}}
                entriesPerPage= {{
                  defaultValue : entriesPerPage,
                  entries : [5,10,15,20,25,50],
                }}
                csv
                date= {true}
                canSearch={true}
                showTotalEntries
                onEntriesChange = {handleEntriesChange}
                totalPages = {Math.ceil(totalEntries / entriesPerPage)}
                />
                </div>
          </SoftBox>

        </Card>
      </div>
    </DashboardLayout>
  )
}
export default Unanswered_questions

 



























































